import './design-system.css';
import './app.css';

import { FC, StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { initAjaxHandlersCommon } from '@servicetitan/ajax-handlers';
import { CULTURE_TOKEN } from '@servicetitan/culture';
import { DateTimeUtils } from '@servicetitan/datetime-utils';
import { Provider } from '@servicetitan/react-ioc';

import { environment, SiteMode } from './api';
import { AppApi, APP_API_TOKEN } from './api/app.api';
import { DOCUMENTATION_API_TOKEN, DocumentationApi } from './api/documentation.api';
import { AUTH_STORE_TOKEN } from './auth';
import { NotificationCenter, NotificationCenterStore } from './common';
import { OktaStore } from './okta';
import { Routes } from './routes';
import { TokenServerStore } from './token-server';

initAjaxHandlersCommon();

export const App: FC = () => (
    <StrictMode>
        <Provider
            singletons={[
                {
                    provide: AUTH_STORE_TOKEN,
                    useClass:
                        environment.site.mode === SiteMode.PartnerApis
                            ? OktaStore
                            : TokenServerStore,
                },
                NotificationCenterStore,
                { provide: APP_API_TOKEN, useClass: AppApi },
                { provide: DOCUMENTATION_API_TOKEN, useClass: DocumentationApi },
                {
                    provide: CULTURE_TOKEN,
                    useValue: {
                        Name: 'en-US',
                    },
                },
                DateTimeUtils,
            ]}
        >
            <BrowserRouter>
                <Routes />
                <NotificationCenter />
            </BrowserRouter>
        </Provider>
    </StrictMode>
);
App.displayName = 'App';
